export default __webpack_public_path__ + "static/media/close.767440b3.svg";